import { render, staticRenderFns } from "./promo.vue?vue&type=template&id=00d4f120&scoped=true&"
import script from "./promo.vue?vue&type=script&lang=js&"
export * from "./promo.vue?vue&type=script&lang=js&"
import style0 from "./promo.vue?vue&type=style&index=0&id=00d4f120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d4f120",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00d4f120')) {
      api.createRecord('00d4f120', component.options)
    } else {
      api.reload('00d4f120', component.options)
    }
    module.hot.accept("./promo.vue?vue&type=template&id=00d4f120&scoped=true&", function () {
      api.rerender('00d4f120', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/promo.vue"
export default component.exports